/**
 * speedtestQuality — Qualitäts-Einstufung für Speedtest-Ergebnisse (Story 5.5)
 *
 * Schwellen 1:1 aus der autoritativen Design-Referenz
 * v2-final/speedtest.html übernommen (`grade()`):
 *
 *   down >= 120 Mb/s  → pill-success ("Excellent")     → hier: good
 *   down >=  80 Mb/s  → pill-primary ("Good")          → hier: warning
 *   sonst             → pill-warning ("Below target")  → hier: poor
 *
 * (StatusChip kennt nur success/warning/danger-Töne, keinen eigenen
 * "primary"-Ton — "warning" und "poor" liegen daher beide auf einer
 * Amber/Rot-Skala statt Blau/Amber wie im Prototyp.)
 */

export type SpeedtestQuality = 'good' | 'warning' | 'poor'

/** Ab dieser Downlink-Rate (Mb/s) gilt der Hotspot als "Excellent". */
export const QUALITY_GOOD_MIN_DOWN_MBPS = 120

/** Ab dieser Downlink-Rate (Mb/s) gilt der Hotspot als "Good" (statt "Below target"). */
export const QUALITY_WARNING_MIN_DOWN_MBPS = 80

/** Bezugsgröße der Downlink-Meter-Anzeige (Mb/s), aus speedtest.html. */
export const METER_MAX_DOWN_MBPS = 200

/**
 * Stuft einen Downlink-Durchschnitt ein.
 * `null`/`undefined` (noch keine verwertbaren Messwerte) → null, kein Badge.
 */
export function speedtestQuality(
  downMbps: number | null | undefined,
): SpeedtestQuality | null {
  if (downMbps === null || downMbps === undefined || Number.isNaN(downMbps)) {
    return null
  }
  if (downMbps >= QUALITY_GOOD_MIN_DOWN_MBPS) return 'good'
  if (downMbps >= QUALITY_WARNING_MIN_DOWN_MBPS) return 'warning'
  return 'poor'
}

/** Füllstand der Downlink-Meter-Leiste in Prozent (0–100). */
export function meterPercent(downMbps: number | null | undefined): number {
  if (downMbps === null || downMbps === undefined || Number.isNaN(downMbps)) {
    return 0
  }
  return Math.min(Math.max(downMbps, 0) / METER_MAX_DOWN_MBPS, 1) * 100
}
